import ReorderRoundedIcon from '@mui/icons-material/ReorderRounded';
import {
  Button,
  CircularProgress,
  List,
  ListItem,
  ListItemButton,
  ListItemText,
  Pagination,
  Stack,
  TextField,
  Tooltip,
} from '@mui/material';
import IconButton from '@mui/material/IconButton';
import Modal from '@mui/material/Modal';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import React, { useState } from 'react';
import { fetchEntities } from './api';

const ENTITIES_PER_PAGE = 50;

export default function EntitiesModal({
  titlePrefix,
  zipId,
  theme,
  entityList,
  buttonText,
}) {
  const entityToolUrl = process.env.REACT_APP_ENTITYTOOL_DETAIL_URL;
  const [open, setOpen] = useState(false);
  const [entities, setEntities] = useState([]);
  const [filteredEntities, setFilteredEntities] = useState([]);
  const [page, setPage] = useState(1);
  const [loading, setLoading] = useState(false);

  const handleClose = () => setOpen(false);

  const handleOpen = async () => {
    setPage(1);
    if (zipId === 'dummy') {
      setEntities(entityList);
      setFilteredEntities(entityList);
      setOpen(true);
    } else {
      setLoading(true);
      try {
        const entities = await fetchEntities(zipId);
        setEntities(entities);
        setFilteredEntities(entities);
        setOpen(true);
      } catch (error) {
        alert(
          `Error ${error} has occurred while trying to fetch the entities for zipId ${zipId}.`
        );
      } finally {
        setLoading(false);
      }
    }
  };

  const openEntityPage = (entity) =>
    window.open(`${entityToolUrl}?search=${entity}`, '_blank');

  const handlePageChange = (event, newPage) => setPage(newPage);

  const handleSearchInputChange = (event) => {
    const regex = new RegExp(`^(${event.target.value})([A-Z0-9]+)*`);
    setPage(1);
    setFilteredEntities(entities.filter((entity) => regex.test(entity)));
  };

  const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    maxHeight: window.innerHeight / 2,
    width: 640,
    bgcolor: 'background.paper',
    boxShadow: 24,
    p: 4,
    overflow: 'auto',
  };

  return (
    <React.Fragment>
      {zipId ? (
        <Tooltip title="See entity list">
          {buttonText ? (
            <Button
              variant="outlined"
              color="primary"
              style={{ textTransform: 'none' }}
              onClick={handleOpen}
            >
              {buttonText}
            </Button>
          ) : (
            <IconButton onClick={handleOpen}>
              <ReorderRoundedIcon />
            </IconButton>
          )}
        </Tooltip>
      ) : null}
      <Modal open={open} onClose={handleClose}>
        <Paper sx={style}>
          <h1
            style={{
              padding: 5,
              top: 0,
              width: 480,
              position: 'sticky',
              zIndex: 999,
              backgroundColor: theme === 'dark' ? '#202020' : '#F8F8F8',
            }}
          >
            <Stack>
              {titlePrefix} Entity List
              <TextField
                onChange={handleSearchInputChange}
                margin="normal"
                size="small"
                label="Search entities..."
              />
            </Stack>
          </h1>
          {loading ? (
            <CircularProgress />
          ) : filteredEntities.length > 0 ? (
            <List>
              {filteredEntities
                .slice((page - 1) * ENTITIES_PER_PAGE, page * ENTITIES_PER_PAGE)
                .map((entity) => (
                  <ListItemButton key={entity} onClick={() => openEntityPage(entity)}>
                    <ListItem style={{ position: 'center' }} disablePadding>
                      <ListItemText
                        primary={
                          <Typography sx={{ textDecoration: 'underline' }}>
                            {entity}
                          </Typography>
                        }
                      />
                    </ListItem>
                  </ListItemButton>
                ))}
            </List>
          ) : (
            <Typography>No entities</Typography>
          )}
          <Pagination
            page={page}
            onChange={handlePageChange}
            count={Math.ceil(filteredEntities.length / ENTITIES_PER_PAGE)}
          />
        </Paper>
      </Modal>
    </React.Fragment>
  );
}
